// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__19ptN","right":"styles_right__2BhxS"};